<template>
  <div @click.stop>
    <div class="overlay overlay--active" v-show="opened" @click.stop="closeBottomToolbar"></div>

    <v-btn ref="fab" color="primary" dark fab fixed bottom @click.stop="openBottomToolbar" right>
      <v-icon>perm_identity</v-icon>
    </v-btn>

    <div id="toolbar" class="bottom-toolbar" @click.stop="closeBottomToolbar">
      <div ref="toolbarRipple" class="color-ripple primary"></div>
      <v-bottom-nav ref="bottomNav" absolute :value="fixedValue" color="primary" :active.sync="fixedValue">
        <v-btn dark value="fixedValue" @click.stop="loginDialog = !loginDialog">
          <span>{{ $t('LBL.LOG_IN') }}</span>
          <v-icon>person</v-icon>
        </v-btn>
        <v-btn dark value="fixedValue" @click.stop="registerDialog = !registerDialog">
          <span>{{ $t('LBL.REGISTER') }}</span>
          <v-icon>playlist_add</v-icon>
        </v-btn>
      </v-bottom-nav>
    </div>

    <login-dialog :show.sync="loginDialog"
      @click-register="registerDialog = !registerDialog"
      @click-password-reset="passwordResetDialog = !passwordResetDialog"></login-dialog>
    <register-dialog :show.sync="registerDialog"
       @click-login="loginDialog = !loginDialog"></register-dialog>
    <password-reset-dialog :show.sync="passwordResetDialog"></password-reset-dialog>
  </div>
</template>

<script>
import anime from 'animejs'
import Vue from 'vue'
import LoginDialog from '@/components/dialogs/LoginDialog'
import RegisterDialog from '@/components/dialogs/RegisterDialog'
import PasswordResetDialog from '@/components/dialogs/PasswordResetDialog'

export default {
  name: 'BottomToolBar',
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  components: {
    'login-dialog': LoginDialog,
    'register-dialog': RegisterDialog,
    'password-reset-dialog': PasswordResetDialog
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  data () {
    return {
      fixedValue: 'fixedValue',
      tl: null,
      opened: false,
      loginDialog: false,
      registerDialog: false,
      passwordResetDialog: false
    }
  },
  methods: {
    openBottomToolbar () {
      this.tl.restart()
      this.opened = true
    },
    closeBottomToolbar () {
      /* closing shouldn't work like this in real use
        this is just for presentation purpose */
      if (this.opened) {
        this.tl.play()
        this.tl.reverse()
        this.opened = false
      }
    },
    onScroll (e) {
      this.closeBottomToolbar()
    }
  },
  mounted () {
    const app = this.$root.$el
    const toolbarRipple = this.$refs['toolbarRipple'].$el
    const fab = this.$refs['fab'].$el
    const bottomNav = this.$refs['bottomNav'].$el

    const appSize = app.getBoundingClientRect()
    const fabSize = fab.getBoundingClientRect()

    this.tl = anime.timeline({
      autoplay: false,
      begin: (anim) => {
        if (this.opened) {
          bottomNav.classList.add('d-flex')
        }
      },
      complete: (anim) => {
        if (!this.opened) {
          bottomNav.classList.remove('d-flex')
        }

        // hack for triggering callback when reverse()
        // https://github.com/juliangarnier/anime/issues/220
        anim.began = anim.completed = false
        anim.loop = anim.progress = 0
      }
    })
      .add({
        targets: fab,
        duration: 200,
        easing: 'easeInOutCubic',
        translateX: -appSize.width / 2 + fabSize.width,
        translateY: fabSize.height / 2,
        opacity: 0
      })
      .add({
        targets: toolbarRipple,
        duration: 200,
        easing: 'easeInOutCirc',
        offset: '-=100',
        width: appSize.width + 10,
        height: appSize.width + 10
      })
      .add({
        targets: bottomNav,
        duration: 200,
        offset: '-=200',
        opacity: 1
      })

    Vue.nextTick(() => {
      this.openBottomToolbar()
    })
  }
}
</script>

<style lang="scss" scoped>
.bottom-toolbar {
  position: fixed;
  overflow: hidden;
  width: 100%;
  height: 56px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  z-index: 2;
}

.color-ripple {
  border-radius: 50%;
  position: fixed;
  width: 0px;
  height: 0px;
}

.bottom-nav {
  opacity: 0;
  display: none;
}

.overlay {
  z-index: 1;

  &:before {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/BottomToolbar.vue